import { useContext, useEffect, useState } from 'react';
import { useIndicatorDashboardContext } from './useIndicatorDashboardContext';
import { InfoIndicatorBlock } from '../settings-blocks/IndicatorInfoCard';
import IndicatorInfo from './IndicatorInfo';
import PayedIndicator from '../settings-blocks/PayedIndicator';
import { checkIsAmbassador } from '../../../../common/services/ambassador';
import { IndicatorDocumentsRow } from '../forms/fields/IndicatorsDocumentRow';
import { PayedUpload } from '../../../../types/Indicators.type';
import { Tabs } from 'flowbite-react';
import { renterTheme } from '../../../renters/components/renter-dashboard/TabsStyle';
import { FaAddressCard, FaUsers } from 'react-icons/fa';
import { CgNotes } from 'react-icons/cg';
import { AuthContext } from '../../../../common/components/auth/authContext/AuthContext';
import IndicatorLeads from './IndicatorLeads';

export function IndicatorDashboard() {
  const { indicator } = useIndicatorDashboardContext();
  const [isAmbassador, setIsAmbassador] = useState(false);
  const { auth } = useContext(AuthContext);

  useEffect(() => {
    const checkAmbassador = async () => {
      if (auth && auth.user) {
        const ambassador = await checkIsAmbassador(auth);
        setIsAmbassador(ambassador);
      }
    };

    if (auth) {
      checkAmbassador();
    }
  }, [auth]);

  if (!indicator) {
    return <div>Loading...</div>;
  }

  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <Tabs
          className="tabs-style"
          theme={renterTheme}
          aria-label="Default tabs"
        >

          <Tabs.Item
            icon={FaAddressCard}
            title={
              <div className="tabs-name-style">
                Informações
              </div>
            }
          >
            <IndicatorInfo />
          </Tabs.Item>

          {!isAmbassador && (
            <Tabs.Item
              icon={CgNotes}
              title={
                <div className="tabs-name-style">
                  Indicador
                </div>
              }
            >
              <div className="tabs-border-line">
                <section className="tabs-item-style">
                  <InfoIndicatorBlock />
                </section>

                <div className="div-tabs-border-line"></div>

                <section className="tabs-item-style">
                  <PayedIndicator data={indicator} />
                </section>

                <div className="div-tabs-border-line"></div>

                <section className="tabs-item-style">
                  <IndicatorDocumentsRow
                    indicatorId={indicator._id as string}
                    currentPath={indicator.payedUpload as PayedUpload[]}
                  />
                </section>
              </div>
            </Tabs.Item>
          )}

          <Tabs.Item
            icon={FaUsers}
            title={
              <div className="tabs-name-style">
                Indicações
              </div>
            }
          >
            <IndicatorLeads />
          </Tabs.Item>

        </Tabs>
      </section>
    </div>
  );
}
